module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget",
    staticStyle: {
      "min-height": "200px"
    }
  }, [(_vm.loading.tela) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Súmula de Alteração em Projeto")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [_vm._v("Dides / Alteração em Projetos ID "), _c('strong', [_vm._v(_vm._s(this.id))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [_vm._v("Brasília (DF),\t" + _vm._s((new Date()).getDate()) + " de " + _vm._s((new Date()).toLocaleString('pt-br', {
    month: 'long'
  })) + " de " + _vm._s((new Date()).getFullYear()))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%",
      "font-style": "italic"
    }
  }, [_vm._v("#interna")])]), _vm._v(" "), (!_vm._.isEmpty(_vm.propostaBackup)) ? _c('div', {
    staticClass: "secao_sumula"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', {
    staticClass: "b3 pad10",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Número e Título do projeto")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.propostaBackup.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.propostaBackup.ds_nome))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Nome da Instituição")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.propostaBackup.projetoSapiens.entidadeParceira.nomfor))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Objetivo Geral")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.propostaBackup.ds_objetivo_geral))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Municípios Atendidos")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm._.join(_vm._.uniq(_vm._.map(_vm.propostaBackup.municipalizacao, function(m) {
    return m.ds_municipio + (_vm._.isNil(m.ds_uf) ? '' : ' (' + m.ds_uf + ')')
  })), ', ')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Valor do projeto")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.map(_vm._.filter(_vm._.flatten(_vm._.map(_vm.propostaBackup.atividades, 'itens_orcamentos')), function(i) {
    return _vm._.includes(['1', '5'], ('' + i.origem).substr(0, 1))
  }), 'valor_total')))))]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Contrapartida")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.map(_vm._.filter(_vm._.flatten(_vm._.map(_vm.propostaBackup.atividades, 'itens_orcamentos')), function(i) {
    return _vm._.includes(['2'], ('' + i.origem).substr(0, 1))
  }), 'valor_total')))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Data de Deferimento")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propostaBackup.projetoSapiens.usu_datdef, "L")))]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Fim do Prazo de Execução")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista"
  }, [_vm._v(_vm._s(_vm.dataFinal))]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Fim de Vigência")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dataFinalVigencia, "L")))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Projeto superior")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.propostaBackup.projetoSapiens.projetoSuperior.numprj) + " - " + _vm._s(_vm.propostaBackup.projetoSapiens.projetoSuperior.nomprj))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.solicitacao.justificativa))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "secao_sumula"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v("Tipo de alteração a ser efetuada no projeto")]), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table"
  }, [(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.metas) > 0) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Alteração de metas")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.contrapartidas) > 0) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Alteração da contrapartida aprovada")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade) !== 0) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Ajustes nas quantidades dos itens de despesa")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[1]) > 0 || _vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[1]) > 0) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Prorrogação de prazo(s)")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[0]) !== _vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[1])) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("Prazo de Execução")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 text-right"
  }, [_vm._v("\n                De "), _c('span', {
    staticClass: "valor_lista"
  }, [_vm._v(_vm._s(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[0]))]), _vm._v(" meses para "), _c('span', {
    staticClass: "valor_lista"
  }, [_vm._v(_vm._s(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoExecucao[1]))]), _vm._v(" meses\n              ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[0]) !== _vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[1])) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("Prazo de Vigência")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 text-right"
  }, [_vm._v("\n                De "), _c('span', {
    staticClass: "valor_lista"
  }, [_vm._v(_vm._s(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[0]))]), _vm._v(" meses para "), _c('span', {
    staticClass: "valor_lista"
  }, [_vm._v(_vm._s(_vm.solicitacao.sumula.resumoAlteracoes.prorrogacaoVigencia[1]))]), _vm._v(" meses\n              ")])]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, function(prc) {
    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
  })) ? [_c('tr', [_c('td', {
    staticClass: "b3 pad10"
  }, [_vm._v("Alteração de Cronograma físico-financeiro")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista text-right"
  }, [_vm._v(_vm._s(_vm._.join(_vm._.map(_vm._.filter(_vm.solicitacao.processos, function(prc) {
    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
  }), 'nome'), ', ')))])]), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.novosItens) > 0) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("\n                  Inclusão de novos itens no projeto\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista text-right"
  }, [_vm._v("\n                  " + _vm._s(_vm.solicitacao.sumula.resumoAlteracoes.novosItens) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.substituicaoItens) > 0) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("\n                  Substituição de itens de despesas constantes do projeto\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista text-right"
  }, [_vm._v("\n                  " + _vm._s(_vm.solicitacao.sumula.resumoAlteracoes.substituicaoItens) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos) > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'REMANEJAMENTO'])) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("\n                  Percentual dos Remanejamentos Concedidos\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista text-right"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("percentage")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos) / 100)) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentoSolicitado) > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'REMANEJAMENTO'])) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("\n                  Remanejamento Solicitado (Valor e Percentual)\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista text-right"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorRemanejado || 0))) + "\n                  "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n                    ( " + _vm._s(_vm._f("percentage")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentoSolicitado))) + " )\n                  ")])])]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, function(prc) {
    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
  })) ? [_c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20",
    staticStyle: {
      "width": "50%",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Débitos")]), _vm._v(" "), _vm._l((_vm._.get(_vm._.find(_vm.solicitacao.processos, function(prc) {
    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
  }), 'alteracao', [])), function(alteracao) {
    return (_vm._.toNumber(alteracao.valorAlteracao[1]) < 0) ? _c('div', _vm._l(([_vm.itemExtrato(alteracao.id)]), function(item) {
      return _c('span', [_c('div', {
        staticClass: "itemExtrato"
      }, [_c('span', {
        staticClass: "itemInformacao"
      }, [_c('span', [_c('span', {
        staticClass: "text-muted"
      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('span', {
        staticClass: "itemDescricao"
      }, [_vm._v(" - " + _vm._s(item.observacao))])]), _vm._v(" "), (alteracao.justificativa) ? _c('span', {
        staticClass: "text-bold"
      }, [_vm._v(_vm._s(alteracao.justificativa[1] ? alteracao.justificativa[1] : ""))]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "itemValores"
      }, [_c('span', {
        staticClass: "itemOrcado"
      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total)))]), _vm._v(" "), _c('span', {
        staticClass: "itemValorAlteracao text-red"
      }, [_vm._v(_vm._s(_vm._f("real")(_vm._.toNumber(alteracao.valorAlteracao[1]))))]), _vm._v(" "), _c('span', {
        staticClass: "itemOrcadoAlterado"
      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total + (_vm._.toNumber(alteracao.valorAlteracao[1])))))])])])])])
    }), 0) : _vm._e()
  })], 2), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 pL20",
    staticStyle: {
      "width": "50%",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Créditos")]), _vm._v(" "), _vm._l((_vm._.get(_vm._.find(_vm.solicitacao.processos, function(prc) {
    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
  }), 'alteracao', [])), function(alteracao) {
    return (_vm._.toNumber(alteracao.valorAlteracao[1]) >= 0) ? _c('div', _vm._l(([_vm.itemExtrato(alteracao.id)]), function(item) {
      return _c('span', [_c('div', {
        staticClass: "itemExtrato"
      }, [_c('span', {
        staticClass: "itemInformacao"
      }, [_c('span', [_c('span', {
        staticClass: "text-muted"
      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('span', {
        staticClass: "itemDescricao"
      }, [_vm._v(" - " + _vm._s(item.observacao))])]), _vm._v(" "), (alteracao.justificativa) ? _c('span', {
        staticClass: "text-bold"
      }, [_vm._v(_vm._s(alteracao.justificativa[1] ? alteracao.justificativa[1] : ""))]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "itemValores"
      }, [_c('span', {
        staticClass: "itemOrcado"
      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total)))]), _vm._v(" "), _c('span', {
        staticClass: "itemValorAlteracao text-green"
      }, [_vm._v("+ " + _vm._s(_vm._f("real")(_vm._.toNumber(alteracao.valorAlteracao[1]))))]), _vm._v(" "), _c('span', {
        staticClass: "itemOrcadoAlterado"
      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_total + (_vm._.toNumber(alteracao.valorAlteracao[1])))))])])])])])
    }), 0) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm._.get(_vm._.find(_vm.solicitacao.processos, function(prc) {
    return _vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], prc.nome)
  }), 'inclusao', [])), function(alteracao) {
    return _c('div', _vm._l(([_vm.itemExtrato(alteracao.id)]), function(item) {
      return _c('span', [_c('div', {
        staticClass: "itemExtrato"
      }, [_c('span', {
        staticClass: "itemInformacao"
      }, [_c('span', [_c('span', {
        staticClass: "label label-info"
      }, [_vm._v("Novo")]), _vm._v(" "), _c('span', {
        staticClass: "text-muted"
      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), _c('span', {
        staticClass: "itemDescricao"
      }, [_vm._v(" - " + _vm._s(item.observacao))])]), _vm._v(" "), _c('span', {
        staticClass: "text-bold"
      }, [_vm._v(_vm._s(item.justificativa))]), _vm._v(" "), _c('span', {
        staticClass: "itemValores"
      }, [_c('span', {
        staticClass: "itemOrcado"
      }, [_vm._v("-")]), _vm._v(" "), _c('span', {
        staticClass: "itemValorAlteracao text-blue"
      }, [_vm._v(_vm._s(_vm._f("real")(item.valorAlteracao)))]), _vm._v(" "), _c('span', {
        staticClass: "itemOrcadoAlterado"
      }, [_vm._v(_vm._s(_vm._f("real")(item.valorAlteracao)))])])])])])
    }), 0)
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentoAcumulado > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'REMANEJAMENTO'])) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("\n                  Percentual Acumulado\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista text-right"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("percentage")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentoAcumulado))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorSuplementacao) > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'SUPLEMENTACAO'])) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("\n                  Valor solicitado de suplementação\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista text-right"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorSuplementacao))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorTotalComSuplementacao) > 0 && _vm._.find(_vm.solicitacao.processos, ['nome', 'SUPLEMENTACAO'])) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("\n                  Valor do projeto após suplementação\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista text-right"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.solicitacao.sumula.resumoAlteracoes.valorTotalComSuplementacao))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, ['nome', 'SUPLEMENTACAO'])) ? _c('tr', [_c('td', {
    staticClass: "b3 pad10 pL20"
  }, [_vm._v("\n                  Enquadramento orçamentário (FEP)\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "b3 pad10 valor_lista text-right"
  }, [_vm._v("\n                  " + _vm._s(_vm.solicitacao.sumula.resumoAlteracoes.enquadramentoOrcamentarioFEP) + "\n                ")])]) : _vm._e()] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "secao_sumula"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v("Verificação de conformidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "sumula_formulario"
  }, [_vm._l((_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
    return !_vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
  })), function(pergunta, idx) {
    return _c('tr', {
      staticClass: "sumula_pergunta"
    }, [_c('td', {
      staticClass: "sumula_codigo"
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sumula_questao",
      domProps: {
        "innerHTML": _vm._s(pergunta.questao)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "sumula_resposta text-center"
    }, [_c('span', {
      staticClass: "valor_lista"
    }, [_vm._v(_vm._s((pergunta.resposta === 'sim' ? 'Sim' : (pergunta.resposta === 'nao' ? 'Não' : (pergunta.resposta === 'pre' ? 'Prejudicado' : '-')))))])])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "sumula_cabecalho_questoes"
  }, [_c('td', {
    staticClass: "sumula_codigo"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "sumula_resposta text-center"
  }, [_c('span', {
    staticClass: "valor_lista"
  }, [_vm._v(_vm._s((_vm.solicitacao.sumula.parceriaEstrategica === 'sim' ? 'Sim' : (_vm.solicitacao.sumula.parceriaEstrategica === 'nao' ? 'Não' : '-'))))])])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
    return _vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
  })), function(pergunta, idx) {
    return (_vm.solicitacao.sumula.parceriaEstrategica === 'sim') ? _c('tr', {
      staticClass: "sumula_pergunta"
    }, [_c('td', {
      staticClass: "sumula_codigo"
    }, [_vm._v(_vm._s(idx + (_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
      return !_vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
    })).length + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sumula_questao",
      domProps: {
        "innerHTML": _vm._s(pergunta.questao)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "sumula_resposta text-center"
    }, [_c('span', {
      staticClass: "valor_lista"
    }, [_vm._v(_vm._s((pergunta.resposta === 'sim' ? 'Sim' : (pergunta.resposta === 'nao' ? 'Não' : (pergunta.resposta === 'pre' ? 'Prejudicado' : '-')))))])])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "secao_sumula"
  }, [_c('div', {
    staticClass: "pad10"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v("Contexto:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.textoContexto))])]), _vm._v(" "), _c('div', {
    staticClass: "pad10"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v("Situação Problema:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.textoSituacaoProblema))])]), _vm._v(" "), _c('div', {
    staticClass: "pad10"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v("Parecer:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.textoParecer))])]), _vm._v(" "), _c('div', {
    staticClass: "pad10"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v("Proposta:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.textoProposta))])]), _vm._v(" "), (_vm._.has(_vm.solicitacao, 'motivoAlteracao.codigo')) ? _c('div', {
    staticClass: "pad10"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v("Motivo:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.motivoAlteracao.codigo.replace('_', ' ')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "secao_sumula"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v("Providências:")]), _vm._v(" "), _c('div', [(_vm.solicitacao.sumula.providencias.length === 0) ? _c('span', [_vm._v("Sem providências")]) : _c('span', [_vm._v(_vm._s(_vm._.join(_vm._.map(_vm.solicitacao.sumula.providencias, 'descricao'), ', ')))])])]), _vm._v(" "), _c('div', {
    staticClass: "secao_sumula"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v("\n          Competências e Alçadas (SIC 1.4.5.1) - Resolução de Competências e Alçadas Direx 2023_00388 de 11.12.2023\n        ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.solicitacao.sumula.alcada.descricao))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "sumula_questao"
  }, [_c('label', [_vm._v("Parceria Estratégica?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secao_sumula"
  }, [_c('div', {
    staticClass: "titulo_secao_sumula"
  }, [_vm._v(" Análise:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e314e20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/sumula.vue
// module id = 1939
// module chunks = 2